import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3qy98km3mq: FaireBrandEntity = {
  token: "b_3qy98km3mq",
  type: "brand",
  name: "Ecozoica Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/f5ee15dbd51daf59d0c4c8aa50139f8b36d409ee35ed0f63fe382a5f11b6924f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/11127a23ceb17758f39bf3fb994a762bdc0170530e9d7f2805d5badaac8c9dcc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f5ee15dbd51daf59d0c4c8aa50139f8b36d409ee35ed0f63fe382a5f11b6924f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/11127a23ceb17758f39bf3fb994a762bdc0170530e9d7f2805d5badaac8c9dcc.jpeg",
  location: "Fort Garland, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    '"Forest-Grade Medicine for the Ecozoic Era"\nEcozoica Apothecary was born of the Sangre de Cristo Mountains — a place where desert meets forest and myth meets matter. At its heart, Ecozoica is about re-enchantment: restoring the sacred connection between humans and the living Earth through plant medicine. The word Ecozoic speaks to a new era — one of ecological consciousness and right relationship with the wild world.\n\nHere, healing is not a product to purchase but a practice of participation — a dialogue between body and Earth. Our work bridges the mythic and the medicinal: the names are archetypes, the plants are teachers, and the process is alchemy. Crafted off-grid and in reverence to the living land, Ecozoica is medicine for those remembering how to belong.\n\nWe call our work forest-grade medicine — herbal formulas crafted in reciprocity with the land, made by hand and sunlight, without extraction from the wild web that sustains us. Every oil, salve, and tincture is solar-infused, small-batch, and built from plants we’ve met in their own habitats — the medicine of place, distilled through time and care.\n\nOur Promise\n* Ethically wildcrafted and organically sourced herbs\n* Solar-infused oils and small-batch production\n* Reusable, recyclable, and compostable packaging\n* No synthetics, parabens, or artificial fragrances — ever',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.688Z",
    importedBy: "entity-db-cli",
  },
};
